<template>
    <v-container class="pa-5" fluid>
        <ConfirmDialog
            :is-open="confirmLeaveDialog"
            @on-confirm="acceptConfirmLeaveDialog"
            @on-abort="closeConfirmLeaveDialog"
        >
            <template #title>
                Opuścić stronę?
            </template>
            <template #content>
                Produkt nie został zapisany. Czy chcesz opuścić stronę?
            </template>
        </ConfirmDialog>

        <page-title>Produkty / {{ product.name }}</page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    class="pa-0"
                    color="primary"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container>
                    <v-card min-height="300">
                        <v-tabs
                            ref="tabs"
                            v-model="tab"
                            slider-color="primary"
                            color="primary"
                            @change="onTabChange"
                        >                    
                            <v-tab> 
                                Cechy produktu
                            </v-tab>
                            <v-tab>
                                komponent
                            </v-tab>
                            <v-tab
                                :disabled="hasProductChanges"
                            >
                                Cechy sklepowe
                            </v-tab>
                        </v-tabs>
                        <v-divider />
                        <v-tabs-items v-model="currentTab">
                            <v-tab-item eager>
                                <ProductFeatures
                                    :product-data="product"
                                    :product-properties="allProductProperties"
                                    :available-product-production-properties="availableProductProductionProperties"
                                    @on-status-change="setProductPropertiesStatusLabel"
                                />
                            </v-tab-item>
                            <v-tab-item eager>
                                <ProductComponentsConfigurator
                                    :product-data="product"
                                    :properties="productProductionProperties"
                                    :components="productComponents"
                                    :processes="productionProcesses"
                                    @on-product-change="onProductChange"
                                    @update-product-data="updateProductData"
                                />
                            </v-tab-item>
                            <v-tab-item eager>
                                <ProductProperties
                                    v-if="product.id"
                                    :product-id="product.id"
                                    :product-properties="productProperties"
                                    :available-product-production-properties="availableProductProductionProperties"
                                    @on-status-change="setProductPropertiesStatusLabel"
                                />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/store'

import PageTitle from '@/components/common/PageTitle'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import ProductComponentsConfigurator from './ProductComponentsConfigurator/Index'
import ProductProperties from './ProductProperties/Index'
import ProductFeatures from './ProductFeatures/Index'

import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'Product',
    components: {
        PageTitle,
        ConfirmDialog,
        ProductComponentsConfigurator,
        ProductProperties,
        ProductFeatures
    },
    beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch('configurations/getProduct', to.params.id),
            store.dispatch('configurations/getProductProductionProperties'),
            store.dispatch('configurations/getProductComponents'),
            store.dispatch('configurations/getProductionProcesses', {paginate: '', query: '?isVirtual=false'}),
            store.dispatch('configurations/getProductPropertiesByProductType', to.params.id),
            store.dispatch('configurations/getProductProperties'),
        ])
            .then(responses => {
                next(vm => {
                    vm.acronym = responses[0].data.acronym
                    vm.product = responses[0].data
                    vm.productProductionProperties = responses[1].data.results
                    vm.productComponents = responses[2].data.results
                    vm.productionProcesses = responses[3].data.results
                    vm.productProperties = responses[4].data.results
                    vm.allProductProperties = responses[5].data.results
                })
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    beforeRouteLeave(to, from, next) {
        if (this.hasProductChanges) {
            this.confirmLeaveDialog = true
            this.confirmLeaveDialogNextRouteName = to.name
        } else {
            next()
        }
    },
    data() {
        return {
            tab: null,
            currentTab: null,
            product: {
                id: null,
                name: null,
                productTypeComponent: []
            },
            productComponents: [],
            productProductionProperties: [],
            productProperties: [],
            allProductProperties: [],
            productionProcesses: [],
            hasUnsolvedProductProperties: false,
            hasProductChanges: false,
            confirmLeaveDialog: false,
            confirmLeaveDialogNextRouteName: null,
            actionLoading: {
                saveProduct: false
            },
        }
    },
    computed: {
        availableProductProductionProperties() {
            let availableProductProductionProperties = []

            this.product.productTypeComponent.forEach(component => {
                component.productTypeComponentProperties.forEach(property => {
                    if (availableProductProductionProperties.length === 0 || !availableProductProductionProperties.some(item => {
                        return item.id === property.productProductionPropertyId
                    })) {
                        availableProductProductionProperties.push(property.productProductionProperty)
                    }
                })
            })

            return availableProductProductionProperties
        }
    },
    methods: {
        setProductPropertiesStatusLabel(value) {
            this.hasUnsolvedProductProperties = value
            this.$refs.tabs.callSlider()
        },
        onTabChange() {
            if (this.tab === 1 && this.hasProductChanges) {
                this.$nextTick(() => {
                    this.tab = this.currentTab
                })

                this.$store.dispatch('showNotification', {
                    type: 'info',
                    message: 'Aby przejść do edycji cech sklepowych należy zapisać zmiany na konfiguracji produktu.'
                })
            } else {
                this.currentTab = this.tab
            }
        },
        onProductChange(hasProductChanges) {
            this.hasProductChanges = hasProductChanges
        },
        updateProductData(product) {
            this.product = product
        },
        closeConfirmLeaveDialog() {
            this.confirmLeaveDialog = false
        },
        acceptConfirmLeaveDialog() {
            this.hasProductChanges = false
            this.$router.push({ name: this.confirmLeaveDialogNextRouteName })
                .catch(error => {
                    errorHandler(error)
                })
        },
        close() {
            this.$router.push({ name: 'configurationsProducts' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>
